import React from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import './css/EyeToggleIcon.css';

export type Props = {
  visible: boolean;
  onClick: () => void;
};

export const EyeToggleIcon: React.FC<Props> = ({ visible, onClick }) => {
  return visible ? (
    <FaEye
      className="toggle-icon"
      color="#444"
      height="1.25em"
      width="1.25em"
      onClick={onClick}
    />
  ) : (
    <FaEyeSlash
      className="toggle-icon"
      color="#888"
      height="1.25em"
      width="1.25em"
      onClick={onClick}
    />
  );
};
